<template>
  <vs-sidebar
    default-index="1"
    :parent="parent"
    :hiddenBackground="$store.getters['IS_SIDEBAR_ACTIVE']"
    class="sidebarx"
    spacer
    v-model="$store.getters['IS_SIDEBAR_ACTIVE']"
    :click-not-close="$store.getters['IS_SIDEBAR_ACTIVE']"
  >
    <vs-sidebar-group title="Sentenance" open>
      <vs-sidebar-item :to="'/yamaha/overview'" index="1" icon="cloud_queue">
        Overview
      </vs-sidebar-item>
      <vs-sidebar-item
        :to="'/dataExport'"
        index="2"
        icon="description"
        v-if="this.username != 'yamahademo'"
      >
        Report
      </vs-sidebar-item>
      <vs-sidebar-item index="2" icon="description">
        <a
          style="padding: 0"
          target="_blank"
          href="https://thaiyamaha.shinee.com/index.php"
        >
          รายงานทส.</a
        >
      </vs-sidebar-item>
      <!-- <vs-button
        style="width: 100%"
        color="success" icon="menu"
        type="filled"
        class="btnSub"
        target
        :href="{ url: 'https://thaiyamaha.shinee.com/index.php' }"
        >รายงานทส.</vs-button
      > -->
      <vs-sidebar-item :to="'/mapdashboard'" index="3" icon="dashboard">
        Dashboard Overview
      </vs-sidebar-item>

      <vs-sidebar-group open title="Dashboard">
        <vs-sidebar-item :to="'/PlasticPaintingWWTPplant'" index="2.1">
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/sidebarIcon/42.png"
          />
          Plastic Painting WWTP
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/AluminiumPaintingWWTPplant'" index="2.1">
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/sidebarIcon/38.png"
          />
          Aluminium Painting WWTP
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/dafplant'" index="2.1">
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/sidebarIcon/40.png"
          />
          DAF Plant
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/centerplant'" index="2.1">
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/sidebarIcon/39.png"
          />
          Center Plant
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/asplant'" index="2.1">
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/sidebarIcon/52.png"
          />
          AS Plant
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/mbrplant'" index="2.1">
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/sidebarIcon/53.png"
          />
          MBR Plant
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/recycleplant'" index="2.1">
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/sidebarIcon/51.png"
          />
          Recycle Plant
        </vs-sidebar-item>

        <vs-sidebar-item :to="'/roplant'" index="2.1">
          <img
            style="width: 13.5%; height: 13.5%"
            src="@/assets/sidebarIcon/36.png"
          />
          RO Plant
        </vs-sidebar-item>
      </vs-sidebar-group>
      <vs-sidebar-group
        title="Device Mangement"
        v-if="this.username != 'yamahademo'"
      >
        <vs-sidebar-item :to="'/sensor'" index="2.2" icon="settings_remote">
          Device
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/gateway'" index="2.3" icon="router">
          Gateway
        </vs-sidebar-item>
        <vs-sidebar-item :to="'/alert'" index="2.4" icon="router">
          Alert
        </vs-sidebar-item>
      </vs-sidebar-group>
      <vs-sidebar-group title="Setting" v-if="this.username != 'yamahademo'">
        <vs-sidebar-item :to="'/network'" index="2.2" icon="wifi">
          Network
        </vs-sidebar-item>
      </vs-sidebar-group>
    </vs-sidebar-group>

    <footer-sidebar slot="footer">
      <div class="footer-sidebar center">
        <div style="margin: 8px; text-align: center">
          <h5
            style="font-size: 0.8rem; font-weight: 550; color: rgb(91, 87, 119)"
          >
            Powered by<img
              class="ml-1"
              src="@/assets/images/logo/swift_logo (1).png"
              style="width: 30%"
            />
          </h5>
        </div>
      </div>
    </footer-sidebar>
  </vs-sidebar>
</template>

<script>
import FooterSidebar from "../FooterSidebar.vue";
export default {
  name: "BetagroSidebar",
  components: {
    FooterSidebar,
  },
  data() {
    return {
      admin: "",
      username: "",
    };
  },
  methods: { goto() {} },
  mounted() {
    this.admin = this.$session.get("admin");
    this.username = this.$session.get("username");
  },
};
</script>

<style>
</style>